// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"3b6ce7c2","308":"aed3c29b","453":"baa6b856","662":"7efbf578","692":"925871a1","770":"f99e564a","815":"f7693401"}[chunkId] + ".chunk.js";
};